import { useState } from "react";
import toast from "react-hot-toast";
import { Button, Modal } from "flowbite-react";
import { HiOutlineExclamationCircle } from "react-icons/hi";
import { removeCampaign } from "../../api/campaigns";

const DeleteModal = ({ campaign, openModal, setOpenModal, fetchCampaigns }) => {
  const [loading, setLoading] = useState(false);

  const handleRemoveCampaign = async () => {
    if (!campaign?._id) return;

    setLoading(true);

    try {
      await removeCampaign(campaign._id);
      await fetchCampaigns();

      toast.success(`Campaign has been archived successfully`);
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message || error.message);
    } finally {
      setLoading(false);
      setOpenModal(false);
    }
  }

  return (
    <Modal show={openModal} size="md" onClose={() => setOpenModal(false)} popup>
      <Modal.Header />
      <Modal.Body>
        <div className="text-center">
          <HiOutlineExclamationCircle className="mx-auto mb-4 size-14 text-gray-400" />
          <h3 className="mb-5 text-lg font-normal text-gray-500">
            Are you sure you want to archive "{campaign?.name}"?
          </h3>
          <div className="flex justify-center gap-4">
            <Button
              color="failure"
              onClick={handleRemoveCampaign}
              disabled={loading}
              isProcessing={loading}
            >
              Yes, I'm sure
            </Button>
            <Button
              color="gray"
              onClick={() => setOpenModal(false)}
              disabled={loading}
            >
              No, cancel
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default DeleteModal;
